import * as React from 'react';

import Imgix from 'js/components/Imgix';

import HomeLogoGridItemModule from 'bundles/composable-page-header/components/grid-items/home-logo/HomeLogoGridItemModule';

import c4bLogo from 'images/composable-page-header-enterprise/c4b-logo.svg';
import c4tLogo from 'images/composable-page-header-enterprise/c4t-logo.svg';

const logoMap = {
  c4t: {
    src: c4tLogo,
    label: 'Coursera for Teams',
    href: '/business/teams',
  },
  c4b: {
    src: c4bLogo,
    label: 'Coursera for Business',
    href: '/business',
  },
} as const;

export type WesLogoProps = {
  /**
   * Type of logo to render, 'c4t' for Coursera for Teams, 'c4b' for Coursera for Business
   * This will determine the logo and the links in the header
   */
  logoType: 'c4t' | 'c4b';
};

function WesLogo(props: WesLogoProps) {
  return (
    <HomeLogoGridItemModule
      logos={[<Imgix src={logoMap[props.logoType].src} alt={logoMap[props.logoType].label} width="240" key="1" />]}
      href={logoMap[props.logoType].href}
      ariaLabel={logoMap[props.logoType].label}
    />
  );
}

export default WesLogo;
